import { StatusChip } from "components/StatusChip";
import { StateWasteStreamRegistrationStatus } from "generated-graphql/graphql";

import { STATUS_COLOR, statusLabel } from "./statusBadgeConstants";

/**
 * The status pill shown in the grid, the registration detail drawer, and the
 * create dialog's status select — one source of truth for the label + color
 * of a registration status so those surfaces can't drift. Renders through
 * StatusChip so it follows the design-system chip spec (soft semantic fill,
 * never MUI's solid dark chip).
 */
export function StatusBadge({ status }: { status: StateWasteStreamRegistrationStatus }) {
  return <StatusChip color={STATUS_COLOR[status]} label={statusLabel(status)} />;
}
